var map = {
	"./cloud.jpg": 6501,
	"./demo.jpg": 6321,
	"./home-hero.jpg": 3128,
	"./scanning.jpg": 4521,
	"./sdk-3.0-space.jpg": 994,
	"./skihelmet.jpg": 8725,
	"./structure-lite-iphone.png": 5591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2270;